import { Eye } from 'lucide-react';
import { formatCount } from '@/lib/clip-engagement';

/** View-count badge for a clip tile. Renders nothing for zero/unknown. */
export function ClipViewCount({ count }: { count: number | undefined }) {
  if (!count) return null;
  return (
    <span
      className="pointer-events-none absolute bottom-2 left-2 z-10 flex items-center gap-1 rounded-full bg-black/60 px-1.5 py-0.5 text-[11px] font-semibold tabular-nums text-white"
      aria-label={`${count} ${count === 1 ? 'view' : 'views'}`}
    >
      <Eye size={12} aria-hidden />
      {formatCount(count)}
    </span>
  );
}
